import { HTMLAttributes } from "react"

export default function Vite(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.8253 9.219L25.1126 44.4686C24.7055 45.1962 23.66 45.2006 23.2468 44.4764L3.14333 9.2223C2.69333 8.433 3.36803 7.47705 4.26233 7.6368L23.9963 11.1642C24.1222 11.1867 24.2511 11.1865 24.3769 11.1636L43.6981 7.6419C44.5894 7.47945 45.2675 8.4282 44.8253 9.219Z"
        fill="url(#paint0_linear_2332_1766)"
      />
      <path
        d="M33.3966 3.01035L18.8086 5.86875C18.692 5.89156 18.5864 5.95248 18.5082 6.04193C18.43 6.13137 18.3838 6.24426 18.3768 6.36285L17.4795 21.5186C17.4585 21.8756 17.7862 22.1526 18.1345 22.0722L22.1961 21.135C22.5762 21.0473 22.9195 21.3821 22.8414 21.7641L21.6348 27.673C21.5535 28.0705 21.9268 28.4108 22.3152 28.2929L24.8238 27.5306C25.2127 27.4125 25.5864 27.7536 25.5042 28.1516L23.5866 37.4331C23.4666 38.0136 24.2388 38.3301 24.5608 37.8324L24.7759 37.5L36.663 13.7772C36.862 13.38 36.519 12.9272 36.0825 13.0113L31.902 13.8182C31.509 13.8939 31.1748 13.5281 31.2856 13.1436L34.0143 3.6846C34.1253 3.2994 33.7899 2.93325 33.3966 3.01035Z"
        fill="url(#paint1_linear_2332_1766)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2332_1766"
          x1="2.65243"
          y1="6.37688"
          x2="27.1852"
          y2="39.6943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#41D1FF" />
          <stop offset="1" stopColor="#BD34FE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2332_1766"
          x1="22.8626"
          y1="3.78629"
          x2="27.3005"
          y2="34.2295"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEA83" />
          <stop offset="0.0833" stopColor="#FFDD35" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
      </defs>
    </svg>
  )
}
